// React
import { memo, useCallback } from "react";

// UI
import { Button } from "ui/components/Button/Button";
import { NumberField } from "ui/components/TextField/NumberField";

// Tipovi
import { PricingTierRowProps } from "./types";

/**
 * Jedan cjenovni razred.
 *
 * Ime polja nosi i polje i indeks (`tier|ratePercent|2`) jer `NumberField` vraća samo ime.
 * Iz njega roditelj zna koji redak i koji stupac mijenja.
 */
const PricingTierRow: React.FC<PricingTierRowProps> = (props: PricingTierRowProps) => {
  const { index, tier, errors, onFieldChange, onRemove } = props;

  const handleRemoveClick = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);

  // Yup putanje za redak niza glase `priceTiers[0].fromVehicle`.
  const fromVehicleError = errors[`priceTiers[${index}].fromVehicle`];
  const ratePercentError = errors[`priceTiers[${index}].ratePercent`];
  const rowErrors = [fromVehicleError, ratePercentError].filter(Boolean);

  return (
    <div>
      {/* Polja dijele širinu retka; fiksne širine su na širokom modalu ostavljale pola praznine. */}
      <div className="flex flex-col md:flex-row gap-3 md:items-end">
        <div className="flex-1">
          <NumberField
            name={`tier|fromVehicle|${index}`}
            label="Od vozila"
            value={tier.fromVehicle}
            onChange={onFieldChange}
            error={fromVehicleError}
            decimals={0}
            size="full"
          />
        </div>

        <div className="flex-1">
          <NumberField
            name={`tier|toVehicle|${index}`}
            label="Do vozila"
            placeholder="Bez granice"
            value={tier.toVehicle}
            onChange={onFieldChange}
            decimals={0}
            size="full"
          />
        </div>

        <div className="flex-1">
          <NumberField
            name={`tier|ratePercent|${index}`}
            label="Udio pune cijene"
            value={tier.ratePercent}
            onChange={onFieldChange}
            error={ratePercentError}
            groupAppend="%"
            decimals={2}
            size="full"
          />
        </div>

        <div className="">
          <Button variant="outlined" children="Ukloni" onClick={handleRemoveClick} />
        </div>
      </div>

      {/* Polja greške pokazuju samo kroz tooltip, pa se ovdje ispisuje i tekst. */}
      {rowErrors.length > 0 && (
        <p className="text-sm text-red-600 mt-1">{rowErrors.join(". ")}</p>
      )}
    </div>
  );
};

export default memo(PricingTierRow);
